import gql from 'graphql-tag';

export default gql`
  fragment accountTagFragment on AccountTag {
    id
    uuid
    name
    color
    poolId
  }
`;
